"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendTypingIndicator;

var _setSendTypingIndicator = require("../actions/setSendTypingIndicator");

var DEFAULT_STATE = false;

function sendTypingIndicator() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setSendTypingIndicator.SET_SEND_TYPING_INDICATOR:
      state = payload.sendTypingIndicator;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwic2VuZFR5cGluZ0luZGljYXRvciIsInN0YXRlIiwicGF5bG9hZCIsInR5cGUiLCJTRVRfU0VORF9UWVBJTkdfSU5ESUNBVE9SIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JlZHVjZXJzL3NlbmRUeXBpbmdJbmRpY2F0b3IuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU0VUX1NFTkRfVFlQSU5HX0lORElDQVRPUiB9IGZyb20gJy4uL2FjdGlvbnMvc2V0U2VuZFR5cGluZ0luZGljYXRvcic7XG5cbmNvbnN0IERFRkFVTFRfU1RBVEUgPSBmYWxzZTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZFR5cGluZ0luZGljYXRvcihzdGF0ZSA9IERFRkFVTFRfU1RBVEUsIHsgcGF5bG9hZCwgdHlwZSB9KSB7XG4gIHN3aXRjaCAodHlwZSkge1xuICAgIGNhc2UgU0VUX1NFTkRfVFlQSU5HX0lORElDQVRPUjpcbiAgICAgIHN0YXRlID0gcGF5bG9hZC5zZW5kVHlwaW5nSW5kaWNhdG9yO1xuICAgICAgYnJlYWs7XG5cbiAgICBkZWZhdWx0OlxuICAgICAgYnJlYWs7XG4gIH1cblxuICByZXR1cm4gc3RhdGU7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxhQUFhLEdBQUcsS0FBdEI7O0FBRWUsU0FBU0MsbUJBQVQsR0FBdUU7RUFBQSxJQUExQ0MsS0FBMEMsdUVBQWxDRixhQUFrQzs7RUFBQTtFQUFBLElBQWpCRyxPQUFpQixRQUFqQkEsT0FBaUI7RUFBQSxJQUFSQyxJQUFRLFFBQVJBLElBQVE7O0VBQ3BGLFFBQVFBLElBQVI7SUFDRSxLQUFLQyxpREFBTDtNQUNFSCxLQUFLLEdBQUdDLE9BQU8sQ0FBQ0YsbUJBQWhCO01BQ0E7O0lBRUY7TUFDRTtFQU5KOztFQVNBLE9BQU9DLEtBQVA7QUFDRCJ9